var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 50.75H50.75M9.66667 43.5H48.3333M14.5 43.5V31.4166M24.1667 43.5V31.4166M33.8333 43.5V31.4166M43.5 43.5V31.4166M29 16.9332L29.0179 16.9169M50.75 24.1666L34.1378 9.40024C32.3198 7.78431 31.4109 6.97637 30.3852 6.66952C29.4814 6.39922 28.5186 6.39922 27.6148 6.66952C26.5891 6.97637 25.6802 7.78431 23.8623 9.40024L7.25 24.1666H50.75Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/Bank_icon.f18f29aa7dc67703f1913cbd53b52ead.svg";
export { ForwardRef as ReactComponent };